import PersonCard from './view';

export default PersonCard;
